module.exports = __webpack_public_path__ + "img/disconnected.e18ca565.svg";